/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import { useSearchParams } from "react-router-dom"
import BreadCrumb from "../components/BreadCrumb"
import { useEffect, useMemo, useState } from "react"
import classNames from "classnames"
import FilterGroup from "../explore/components/FilterGroup"
import { ModelSearchResponse } from "../../api/__gen__/data-contracts"
import { getSearchResult } from "../components/search-bar/api"

export const SearchResultsTabs = ({
  setCurrentTab,
  currentTab = 'apis'
}: any) => {
  const TABS = [
    {
      name: 'apis',
      label: 'APIs',
    },
    {
      name: 'tables',
      label: 'Tables',
    },
    {
      name: 'queries',
      label: 'Queries',
    },
    {
      name: 'dashboards',
      label: 'Dashboards',
    },
  ]

  return <div role="tablist" className="tabs">
    {
      TABS.map((tab, index) => {
        return <a role="tab" className={classNames("tab mb-[-2px] px-0 mr-4 h-[2.5rem] font-semibold", {
          'tab-active border-b-2 ': tab.name === currentTab
        })} key={index} onClick={() => {
          setCurrentTab(tab.name)
        }}>{tab.label}</a>
      })
    }
  </div>
}

const SearchResultsItem = ({ item, name, description }: any) => {

  return <div className="mt-3">
    <div className="font-semibold">
      {
        name || 'No name'
      }
    </div>
    <div className="text-sm text-[#999ca0]">
      {
        description || 'No description'
      }
    </div>
  </div>
}

const SearchResults = () => {


  const [searchResult, setSearchResult] = useState<ModelSearchResponse>({
    apis: [],
    tables: [],
    // dashboard: []
  })

  const [isLoading, setIsLoading] = useState(false)

  // TODO: make this as a provider and use it in other components
  const fetchAndSetResult = async (keyword: string) => {
    setIsLoading(true)
    const res = await getSearchResult(keyword)

    setSearchResult(res.data)

    setIsLoading(false)

    // setData
  }

  // search params
  const [searchParams, setSearchParams] = useSearchParams()
  const keyword = searchParams.get('keyword')

  useEffect(() => {
    if (keyword) {
      fetchAndSetResult(keyword)
    }
  }, [keyword])


  const [currentTab, setCurrentTab] = useState('apis')

  const renderSearchResults = () => {
    switch (currentTab) {
      case 'apis':
        return <div>
          {searchResult.apis?.map((item, index) => {
            return <SearchResultsItem key={index}
              name={item.display_name}
              description={item.summary}
            />
          })}
        </div>
      case 'queries':
        return <div>
          {searchResult.queries?.map((item, index) => {
            return <SearchResultsItem key={index}
              name={item.display_name}
              description={item.description}
            />
          })}
        </div>
      case 'dashboards':
        return <div>
          {searchResult.dashboards?.map((item, index) => {
            return <SearchResultsItem item={item} key={index}
              name={item.display_name}
              description={item.description}
            />
          })}
        </div>
      case 'tables':
        return <div>
          {searchResult.tables?.map((item, index) => {
            return <SearchResultsItem item={item} key={index}
              name={item.name}
              description={item.summary}
            />
          })}
        </div>

      default:
        return null
    }
  }

  const numberOfResults = useMemo(() => {
    return (searchResult.apis?.length || 0) + (searchResult.queries?.length || 0) + (searchResult.dashboards?.length || 0) + (searchResult.tables?.length || 0)
  }, [searchResult])

  return <div>
    {/* Breadcrumb */}
    <div className="border-b-2 px-6 py-3 flex justify-between items-center">
      <BreadCrumb>
        Explore
        <span className="mx-3">/</span>
        Search Results for {`"${keyword}"`}
      </BreadCrumb>
    </div>
    <div className="px-[80px] py-10">

      {/* Search Results Title */}
      <div>
        {/* Result */}
        <div className="text-3xl mb-1 font-semibold">
          Search Results for {`"${keyword}"`}
        </div>
        <div className="text-[#999ca0] font-semibold">
          {
            numberOfResults
          } results found
        </div>
      </div>

      {/* Search Result Tabs */}
      <div className="mt-6">

        <div className="border-b-2 w-full flex justify-between items-center">
          <SearchResultsTabs setCurrentTab={setCurrentTab} currentTab={currentTab} />
          <FilterGroup />
        </div>
      </div>

      <div className="mt-6">
        {renderSearchResults()}
      </div>

    </div>



  </div>
}

export default SearchResults